
import Stickyfill from 'stickyfilljs'
export default () => {
    var elements = document.querySelectorAll('.sticky');
    Stickyfill.add(elements);
    }